export class RequestedStopInventoryWrite {
    constructor(json) {
        this.id = json.id;
        this.quantity = json.quantity;
        this.inventorySubTypeId = json.inventory_sub_type_id;
    }
}
export class RequestedStopInventory extends RequestedStopInventoryWrite {
    constructor(json) {
        super(json);
        this.inventorySubTypeName = json.inventory_sub_type_name;
        this.inventoryTypeId = json.inventory_type_id;
        this.inventoryTypeName = json.inventory_type_name;
    }
}
//# sourceMappingURL=RequestedStopInventory.js.map